import React from 'react';
import styled from 'styled-components';
const InlineLink = styled.a `
  color: ${({ color }) => color || 'inherit'};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'inherit')};
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
`;
/**
 * ImpInlineLink is a hyperlink component that allows navigation to a specified URL. It offers customization options like color and the ability to open links in a new tab, and it also supports accessibility features.
 *
 * @component
 * @example
 * <ImpInlineLink url="https://example.com" openInNewTab>
 *   Visit Example
 * </ImpInlineLink>
 *
 * @param {object} props - The component props.
 * @param {string} props.url - The URL that the hyperlink points to.
 * @param {string} [props.ariaLabel] - A descriptive label that provides additional information about the link, especially for screen reader users.
 * @param {string} [props.color="inherit"] - The color of the hyperlink text. Defaults to inheriting the parent's color.
 * @param {boolean} [props.openInNewTab=true] - A flag that determines whether the link should open in a new tab or the current window. Defaults to true.
 * @param {React.ReactNode} props.children - The content inside the hyperlink, typically text or an inline image.
 * @param {Function} [props.onClick] - A callback function that is invoked when the link is clicked.
 *
 * @returns {JSX.Element} The rendered component.
 */
function ImpInlineLink({ openInNewTab = true, branded = false, onClick, underline = false, bold = false, ariaLabel, url, color, children, }) {
    const getColor = (branded, color) => {
        if (branded) {
            return 'var(--merchant-color)';
        }
        return color;
    };
    return (React.createElement(InlineLink, { href: url, color: getColor(branded, color), underline: underline, bold: bold, target: openInNewTab ? '_blank' : '_self', rel: openInNewTab ? 'noopener noreferrer' : undefined, "aria-label": ariaLabel, onClick: onClick, "data-testid": "inline-link" }, children));
}
export default ImpInlineLink;
//# sourceMappingURL=ImpInlineLink.js.map